<template>
    <div style="background: white; border-radius: 5px;">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px">
            <h4 style="margin-bottom: 0;">Danh sách lớp phát hành hoá đơn thuế</h4>
            <el-button :loading="isExporting" class="text-white" style="border: none" type="primary"
                       @click="exportClassInvoice">
                <i class="el-icon-download text-white"></i>
                <span v-if="!isExporting">Export</span>
                <span v-else>{{ percent }}%</span>
            </el-button>
        </div>
        <hr style="padding: 0; margin: 0"/>
        <div v-loading="loading" style="padding:15px 20px">
            <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0">
                <div class="grid-filter">

                    <div class="display-flex-column">
                        <span>Tên khách hàng</span>
                        <el-input
                            v-model="queryFilter.keyword"
                            clearable
                            placeholder="Nhập tên khách hàng"
                            suffix-icon="el-icon-search"
                            @change="handleSearch"
                        >
                        </el-input>
                    </div>
                    <div class="display-flex-column">
                        <span>Số điện thoại</span>
                        <el-input
                            v-model="queryFilter.phone"
                            clearable
                            placeholder="Nhập số điện thoại"
                            suffix-icon="el-icon-search"
                            @change="handleSearch"
                        >
                        </el-input>
                    </div>
                    <div class="display-flex-column">
                        <span>Trung tâm</span>
                        <el-select v-model="queryFilter.center_id" clearable multiple placeholder="Chọn chọn trung tâm"
                                   style="width: 100%" @change="handleSearch">
                            <el-option
                                v-for="item in centers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="display-flex-column">
                        <span>Năm </span>
                        <el-date-picker
                            v-model="queryFilter.year"
                            format="yyyy"
                            placeholder="Chọn năm"
                            type="year"
                            value-format="yyyy"
                            @change="handleSearch">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="example-preview table-responsive h-100 mt-8">
                <table class="table table-vertical-center table-bordered">
                    <thead>
                    <tr style="background-color: #F8F8F8;">
                        <th class="min-w-[80px]" scope="col"
                            style="background: #F8F8F8;white-space: nowrap; text-align: start">Mã học viên
                        </th>
                        <th class="min-w-[80px]" scope="col"
                            style="background: #F8F8F8;white-space: nowrap; text-align: start">Tên khách hàng
                        </th>
                        <th class="min-w-[40px]" scope="col" style="background: #F8F8F8; text-align: start;">Số điện
                            thoại
                        </th>
                        <th class="min-w-[40px]" scope="col" style="background: #F8F8F8; text-align: start;">Mã hợp
                            đồng
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Khoá học
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Giá trị
                            khoá
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Mã lớp</th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Chi nhánh
                            học
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Lịch học
                            (Giờ học)
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Ngày bắt
                            đầu lớp
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Ngày kết
                            thúc (dự kiến)
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Ngày học
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Buổi học
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Tổng số
                            buổi
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Doanh thu
                            buổi học
                        </th>
                        <th class="min-w-[80px]" scope="col" style="background: #F8F8F8; text-align: start;">Giáo viên
                            phụ trách
                        </th>
                    </tr>
                    </thead>
                    <tbody v-if="TaxInvoiceList.length > 0">
                    <tr v-for="(invoice, index) of TaxInvoiceList"
                        :key="`${invoice.contract_id}-${invoice.user_id}-${index}`"
                        style="border: 1px solid #EBEDF3; border-top: 0">
                        <td style="text-align: start">{{ invoice.user_id }}</td>
                        <td style="text-align: start">{{ invoice.name }}</td>
                        <td style="text-align: start">{{ invoice.phone }}</td>
                        <td style="text-align: start">{{ invoice.contract_id }}</td>
                        <td style="text-align: start">{{ invoice.course_name }}</td>
                        <td>{{ invoice.course_value | formatPrice }}</td>
                        <td>{{ invoice.ten_lop }}</td>
                        <td>{{ invoice.ten_chi_nhanh }}</td>
                        <td style="text-align: start">{{ invoice.lich_hoc }}</td>
                        <td style="text-align: start"> {{ invoice.ngay_bat_dau_lop }}</td>
                        <td style="text-align: start"> {{ invoice.ngay_ket_thuc_lop }}</td>
                        <td style="text-align: start"> {{ invoice.date_time }}</td>
                        <td style="text-align: start"> {{ invoice.lesson_string }}</td>
                        <td style="text-align: start"> {{ invoice.total }}</td>
                        <td style="text-align: start"> {{ invoice.doanh_thu_buoi_hoc | formatPrice }}</td>
                        <td style="text-align: start"> {{ invoice.teacher_name }}</td>

                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td class="event-title no-data" colspan="16" style="text-align: center">Chưa có dữ liệu</td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="TaxInvoiceList?.length > 0">
                    <div class="edu-paginate mx-auto text-center mt-10 mb-5"
                         style="display: flex; justify-content: center; align-items: center; height: 50px">
                        <paginate
                            v-model="page"
                            :click-handler="changePage"
                            :container-class="'pagination b-pagination'"
                            :margin-pages="1"
                            :next-class="'page-link'"
                            :next-link-class="'next-link-item'"
                            :next-text="'Sau'"
                            :page-class="'page-item'"
                            :page-count="lastPage"
                            :page-range="3"
                            :pageLinkClass="'page-link'"
                            :prev-class="'page-link'"
                            :prev-link-class="'prev-link-item'"
                            :prev-text="'Trước'"
                        >
                        </paginate>
                    </div>
                    <div class="w-100" style="display: flex; justify-content: end; margin-top: -50px">
                        <div>
                            Tổng số bản ghi: <span
                            style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{
                                this.total ?? TaxInvoiceList.length
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {juridicalOption, statusInvoice, typeInvoice} from "@/common/define";
import {CLASSROOM_TAX_INVOICE} from "@/core/services/store/tax-invoice/tax-invoice.module";
import TaxInvoiceClassItem from "./model/TaxInvoiceClassItem";
import {GET_CENTER_TAG_E} from "@/core/services/store/task-management/task-management.module";
import {exportExcel} from "@/core/filters";

export default {
    data() {
        return {
            loading: false,
            isExporting: false,
            page: 1,
            lastPage: 1,
            total: 0,
            TaxInvoiceList: [],
            statusInvoice,
            typeInvoice,
            juridicalOption,
            percent: 0,
            centers: [],
            confirmCancel: false,
            taxInvoiceSelected: null,
            statusSelectedInvoice: null,
            queryFilter: {
                keyword: null,
                year: null,
                phone: null,
                center_id: null,
            },
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý báo cáo"},
            {title: "Danh sách học viên phát hành hoá đơn thuế", name: 'TaxInvoiceList'}
        ]);
        this.getTaxInvoiceList()
        this.getAllCenterActive()
    },
    methods: {
        changePage(obj) {
            this.page = obj;
            this.getTaxInvoiceList()
        },
        getTaxInvoiceList() {
            this.getParams()
            this.callApi()
        },
        async handleSearch() {
            this.page = 1
            await this.queryFilterTaxInvoice()
            this.getTaxInvoiceList()
        },

        async callApi() {
            this.loading = true
            const payload = {
                page: this.page,
                keyword: this.queryFilter.keyword,
                phone: this.queryFilter.phone,
                center_id: this.queryFilter.center_id,
                year: this.queryFilter.year,
            }
            try {
                const res = await this.$store.dispatch(CLASSROOM_TAX_INVOICE, payload)
                if (!res.error) {
                    console.log(res.data);
                    const data = res.data
                    this.page = data.current_page
                    this.lastPage = data.last_page
                    this.total = data.total
                    if (data?.data?.length > 0) {
                        this.TaxInvoiceList = data?.data?.map(item => new TaxInvoiceClassItem(item)) ?? []
                    } else {
                        this.TaxInvoiceList = []
                    }
                }
            } catch (e) {
                console.log(e, 'error')
            } finally {
                this.loading = false
            }
        },
        getParams() {
            const query = this.$route.query
            this.queryFilter.keyword = query.keyword ?? null
            this.queryFilter.phone = query.phone ?? null
            this.queryFilter.center_id = query.center_id ?? null
            this.queryFilter.year = query.year ?? null
        },

        getAllCenterActive() {
            const payload = {
                limit: 10000,
                is_edutalk: 1,
                status: 1,
            }
            this.$store.dispatch(GET_CENTER_TAG_E, payload).then(res => {
                if (!res.error) {
                    this.centers = res.data?.data
                }
            })
        },

        async queryFilterTaxInvoice() {
            await this.$router.push({
                name: 'ClassInvoice',
                query: {
                    ...this.queryFilter,
                },
            })
        },
        mapExportRow(item) {
            return {
                user_id: item.user_id,
                name: item.name,
                phone: item.phone,
                contract_id: item.contract_id,
                course_name: item.course_name,
                course_value: item.course_value,
                ten_lop: item.ten_lop,
                ten_chi_nhanh: item.ten_chi_nhanh,
                lich_hoc: item.lich_hoc,
                ngay_bat_dau_lop: item.ngay_bat_dau_lop,
                ngay_ket_thuc_lop: item.ngay_ket_thuc_lop,
                date_time: item.date_time,
                lesson_string: item.lesson_string,
                total: item.total,
                doanh_thu_buoi_hoc: item.doanh_thu_buoi_hoc,
                teacher_name: item.teacher_name,
            }
        },

        async exportClassInvoice() {
            const HEADER_ROW_EXPORT_CLASS_TAX_INVOICE = [
                {key: 'user_id', value: 'Mã học viên'},
                {key: 'name', value: 'Tên khách hàng'},
                {key: 'phone', value: 'Số điện thoại'},
                {key: 'contract_id', value: 'Mã hợp đồng'},
                {key: 'course_name', value: 'Khoá học'},
                {key: 'course_value', value: 'Giá trị khoá'},
                {key: 'ten_lop', value: 'Mã lớp'},
                {key: 'ten_chi_nhanh', value: 'Chi nhánh học'},
                {key: 'lich_hoc', value: 'Lịch học (Giờ học)'},
                {key: 'ngay_bat_dau_lop', value: 'Ngày bắt đầu lớp'},
                {key: 'ngay_ket_thuc_lop', value: 'Ngày kết thúc (dự kiến)'},
                {key: 'date_time', value: 'Ngày học'},
                {key: 'lesson_string', value: 'Buổi học'},
                {key: 'total', value: 'Tổng số buổi'},
                {key: 'doanh_thu_buoi_hoc', value: 'Doanh thu buổi học'},
                {key: 'teacher_name', value: 'Giáo viên phụ trách'},
            ]
            const basePayload = {
                keyword: this.queryFilter.keyword,
                phone: this.queryFilter.phone,
                center_id: this.queryFilter.center_id,
                year: this.queryFilter.year,
                per_page: 1000,
            }
            this.isExporting = true
            try {
                const firstRes = await this.$store.dispatch(CLASSROOM_TAX_INVOICE, {...basePayload, page: 1})
                if (firstRes.error) {
                    this.$bvToast.toast(firstRes?.data?.message || 'Export thất bại', {
                        title: 'Export excel',
                        variant: 'danger',
                        solid: true,
                    })
                    return
                }

                const firstPage = firstRes?.data || {}
                const totalPages = Number(firstPage.last_page || 1)
                let exportRows = (firstPage.data || []).map(item => this.mapExportRow(new TaxInvoiceClassItem(item)))
                this.percent = totalPages > 0 ? Math.round((1 / totalPages) * 100) : 0
                for (let page = 2; page <= totalPages; page++) {
                    const pageRes = await this.$store.dispatch(CLASSROOM_TAX_INVOICE, {...basePayload, page})
                    if (pageRes.error) {
                        continue
                    }
                    const pageRows = (pageRes?.data?.data || []).map(item => this.mapExportRow(new TaxInvoiceClassItem(item)))
                    exportRows = [...exportRows, ...pageRows]
                    this.percent = Math.min(100, Math.round((page / totalPages) * 100))
                }

                this.percent = 100
                exportExcel(HEADER_ROW_EXPORT_CLASS_TAX_INVOICE, exportRows, "Danh sách lớp phát hành hoá đơn thuế.xlsx", false)
            } catch (e) {
                this.$bvToast.toast('Export thất bại', {
                    title: 'Export excel',
                    variant: 'danger',
                    solid: true,
                })
                console.log(e, 'error')
            } finally {
                this.isExporting = false
                setTimeout(() => {
                    this.percent = 0
                }, 500)
            }
            8348
            9114
            10431
        },

    }
}
</script>

<style scoped>
.bg-waiting {
    background: #FF9900;
}

.bg-success {
    background: #1BC5BD;
    color: white;
}

.bg-fail {
    background: #F50B0B;
    color: white;
}

.bg-cancel {
    color: white;
    background: #6E6E6E
}

.bg-blue-500 {
    background: #0066FF;
    color: white;
}

.display-flex-column {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.grid-filter {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
    .grid-filter {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 10px 30px;
    }
}
</style>